import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, useContext } from 'react'

import { CartV2Totals } from '@Domains/Cart/Feature/CartV2/CartV2'
import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './CheckoutTotals.module.scss'

export interface CheckoutTotalsProps {
  totals: CartV2Totals
}

export const CheckoutTotals: FC<CheckoutTotalsProps> = ({ totals }) => {
  const { t } = useTranslation()
  const { store } = useContext(MetadataContext)
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const countryCode = store?.config?.countryCode
  return (
    <div className={clsx(styles.checkoutTotals, cofDesignV1 && styles.cofDesignV1)}>
      {map((totals || []), total => (
        <span key={total.id} className={clsx(styles.amount, total.style.toLowerCase())} id={total.id}>
          <p>{total.title}</p>
          <p>{total.text || total.value?.format}</p>
        </span>
      ))}

      {countryCode === 'NO' && <span className={styles.taxesAndDuties}>Inkl. toll/MVA</span>}
      {countryCode && ['US', 'SG', 'AU', 'NZ'].includes(countryCode) && (
        <span className={styles.taxesAndDuties}>{t('common:DUTIES_EXCL_SALES_TAX')}</span>
      )}
    </div>
  )
}

